module.exports = __webpack_public_path__ + "img/g_wan.a27aad4e.png";